import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from '@/App';
import { AvisoAtualizacao } from '@/lib/pwa';
import '@/index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AvisoAtualizacao />
      <App />
    </BrowserRouter>
  </StrictMode>,
);
